/**
 * Copyright 2026 Perform Content Services Limited. Confidential and Proprietary. All Rights Reserved.
 */

import Chunk from '../Chunk';
import {RtpTimestamp} from '../../frameTiming/FrameTimingInformation';
import {DecodedFrameTimingInformationPayload} from './transforms/frameTimingInformation';

export enum TransformMessageType {
  Error = -1,
  AddTransform = 0,
  ConfigurePipeline = 1,
  Metadata = 2,
  Chunk = 3,
  PipelineConfigured = 4
}

export enum TransformMessageDataType {
  FrameTimingInformation = 0,
  EncodedVideoChunk = 1,
  EncodedAudioChunk = 2,
  SurrogateVideoChunk = 3,
  SurrogateAudioChunk = 4
}

export type TransformMessagePayload<T> = {
  type: TransformMessageDataType;
  data: T;
};

type WebRTCInsertableStreams = {
  source: ReadableStream;
  sink: WritableStream;
};

export type TransformStreamMetadata = DecodedFrameTimingInformationPayload;
export type MetadataMessagePayload = {[timestamp: RtpTimestamp]: {decodedFrameTimingInformation: TransformStreamMetadata}};

type TransformName = string;
export type TransformMessage =
  | {
      type: TransformMessageType.AddTransform;
      data: TransformName;
    }
  | {
      type: TransformMessageType.ConfigurePipeline;
      data: WebRTCInsertableStreams;
    }
  | {
      type: TransformMessageType.Metadata;
      data: TransformMessagePayload<MetadataMessagePayload>;
    }
  | {
      type: TransformMessageType.Chunk;
      data: TransformMessagePayload<Chunk>;
    };